export type Language = 'zh' | 'en';

export interface Translations {
  // Logo
  logoTitle: string;
  logoSubtitle: string;
  tagline: string;

  // Hero
  heroTitle: string;
  heroSubtitle: string;
  heroPlaceholder: string;
  heroExample1: string;
  heroExample2: string;
  heroExample3: string;

  // Search
  searchButton: string;
  searching: string;
  searchResults: string;
  noResults: string;
  tryDifferent: string;

  // Filters
  filters: string;
  genre: string;
  year: string;
  rating: string;
  allGenres: string;
  allYears: string;
  allRatings: string;

  // Movie Card
  director: string;
  actors: string;
  rating: string;
  watchOn: string;
  recommendation: string;
  reasonHeader: string;

  // Stats
  statsMovies: string;
  statsAI: string;
  statsHours: string;

  // Footer
  footerMadeWith: string;
  footerCopyright: string;
  footerDisclaimer: string;
  footerGithub: string;
  footerFeedback: string;

  // Language
  langName: string;
}

export const translations: Record<Language, Translations> = {
  zh: {
    logoTitle: 'Douya Movie',
    logoSubtitle: 'AI驱动的电影推荐引擎',
    tagline: '用自然语言找到你想看的电影',

    heroTitle: '找到你想看的电影',
    heroSubtitle: '不需要记电影名，用自然语言描述你的心情，AI为你推荐最合适的电影',
    heroPlaceholder: '例如：适合情侣周末看的浪漫电影',
    heroExample1: '😊 让人心情愉悦的喜剧',
    heroExample2: '🎭 剧情反转多的悬疑片',
    heroExample3: '💭 让人思考人生的电影',

    searchButton: '搜索',
    searching: '搜索中...',
    searchResults: '搜索结果',
    noResults: '没有找到匹配的电影',
    tryDifferent: '试试换个描述方式',

    filters: '筛选',
    genre: '类型',
    year: '年代',
    rating: '评分',
    allGenres: '全部类型',
    allYears: '全部年代',
    allRatings: '全部评分',

    director: '导演',
    actors: '主演',
    watchOn: '查看详情',
    recommendation: '推荐理由',
    reasonHeader: '为什么推荐这部',

    statsMovies: '部电影',
    statsAI: 'AI推荐',
    statsHours: '7x24小时',

    footerMadeWith: 'Douya 团队',
    footerCopyright: '© 2026 Douya Movie. 本站仅提供电影信息，不提供在线播放服务。',
    footerDisclaimer: '电影数据和海报来源于网络，如有侵权请联系删除。',
    footerGithub: 'GitHub',
    footerFeedback: '反馈',

    langName: '中文'
  },
  en: {
    logoTitle: 'Douya Movie',
    logoSubtitle: 'AI-Powered Movie Recommendation',
    tagline: 'Find your perfect movie with natural language',

    heroTitle: 'Find Movies You\'ll Love',
    heroSubtitle: 'No need to remember movie titles. Just describe your mood, and AI will recommend the perfect films for you.',
    heroPlaceholder: 'e.g., Romantic movies for a weekend date',
    heroExample1: '😊 Feel-good comedies',
    heroExample2: '🎭 Mind-bending thrillers',
    heroExample3: '💭 Movies that make you think',

    searchButton: 'Search',
    searching: 'Searching...',
    searchResults: 'Search Results',
    noResults: 'No matching movies found',
    tryDifferent: 'Try a different description',

    filters: 'Filters',
    genre: 'Genre',
    year: 'Year',
    rating: 'Rating',
    allGenres: 'All Genres',
    allYears: 'All Years',
    allRatings: 'All Ratings',

    director: 'Director',
    actors: 'Cast',
    watchOn: 'View Details',
    recommendation: 'Recommendation',
    reasonHeader: 'Why we recommend this',

    statsMovies: 'Movies',
    statsAI: 'AI-Powered',
    statsHours: '7x24 Hours',

    footerMadeWith: 'Douya Team',
    footerCopyright: '© 2026 Douya Movie. Movie information only, no streaming service.',
    footerDisclaimer: 'Movie data and posters from web, contact for removal if infringement.',
    footerGithub: 'GitHub',
    footerFeedback: 'Feedback',

    langName: 'English'
  }
};

export function detectBrowserLanguage(): Language {
  const browserLang = navigator.language || (navigator as any).userLanguage;
  if (browserLang.startsWith('zh')) {
    return 'zh';
  }
  return 'en';
}

export const allLanguages = [
  { code: 'zh' as Language, name: 'Chinese', nativeName: '中文' },
  { code: 'en' as Language, name: 'English', nativeName: 'English' }
];
